import React, {useState} from 'react';
import Box from "@mui/joy/Box";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, {tabClasses} from "@mui/joy/Tab";
import TabPanel from "@mui/joy/TabPanel";
import {BalancePage} from "./balance/BalancePage";
import {PaymentMethodsStatsTab} from "./paymentMethods/PaymentMethodsStatsTab";
import {ChartsTab} from "./depositWithdrawal/ChartsTab";
import TablesTab from "./depositWithdrawal/TablesTab";

interface StatisticsTabProps {
    currentTabIndex?: number;
    onTabChange?: (index: number) => void;
}

export function StatisticsTab({ currentTabIndex = 0, onTabChange }: StatisticsTabProps) {
    const [activeStatsTab, setActiveStatsTab] = useState(currentTabIndex);

    React.useEffect(() => {
        setActiveStatsTab(currentTabIndex);
    }, [currentTabIndex]);
    return (
        <Box sx={{ width: '100%' }}>
            <Tabs 
                value={activeStatsTab} 
                onChange={(event, newValue) => {
                    const idx = (newValue as number) ?? 0;
                    setActiveStatsTab(idx);
                    onTabChange?.(idx);
                }}
                sx={{bgcolor: 'transparent'}}
            >
                <TabList
                    tabFlex={1}
                    size="sm"
                    sx={{
                        pl: {xs: 0, md: 4},
                        justifyContent: 'left',
                        [`&& .${tabClasses.root}`]: {
                            fontWeight: '600',
                            flex: 'initial',
                            color: 'text.tertiary',
                            [`&.${tabClasses.selected}`]: {
                                bgcolor: 'transparent',
                                color: 'text.primary',
                                '&::after': {
                                    height: '2px',
                                    bgcolor: 'primary.500',
                                },
                            },
                        },
                    }}
                >
                    <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={0}>
                        Баланс
                    </Tab>
                    <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={1}>
                        Методы оплаты
                    </Tab>
                    <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={2}>
                        Пополнения и Выводы Графики
                    </Tab>
                    <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={3}>
                        Пополнения и Выводы Таблицы
                    </Tab>
                </TabList>
                
                <TabPanel value={0}>
                    <BalancePage />
                </TabPanel>
                
                <TabPanel value={1}>
                    <PaymentMethodsStatsTab />
                </TabPanel>
                
                <TabPanel value={2}>
                    <ChartsTab />
                </TabPanel>
                
                <TabPanel value={3}>
                    <TablesTab />
                </TabPanel>
            </Tabs>
        </Box>
    );
}
